var niceSelectInit;

(function ($) {

	const selectors = {
		select: 'select:not(.no-js)',
	}

	niceSelectInit = function () {
		$(selectors.select).niceSelect();
	}

})(jQuery);


export default niceSelectInit;